/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import TableReportSection from "../../../../../material/tablereportsection/tablereportsection";
// styles
import injectSheet from 'react-jss';
import styles from './toparticlesreport_styles';
import { fetchTopArticlesExportAll } from 'state/thunks/trendingnowv2';
import { SingleSelectDropDown, Tip } from '@insticator/insticator-ui/dist/material';
import Space from 'material/space/space';


const articlesMetricOptions = [
    {name: 'Page View', value: 'page_loads'},
    {name: 'Comments', value: 'comments'},
    {name: 'Reactions', value: 'reactions'},
    {name: 'Total', value: 'total'}
]

const defaultColumns = [
    {
        key: 'rank',
        title: 'Rank'
    },
    {
        key: 'title',
        title: 'Title',
        url: 'pageUrl'
    }
]
const pageViewsColumns = [
    ...defaultColumns,
    {
        key: 'count',
        title: 'Page Views',
        format: 'comma'
    }
]

const commentsColumns = [
    ...defaultColumns,
    {
        key: 'count',
        title: 'Comments',
        format: 'comma'
    }
]

const reactionsColumns = [
    ...defaultColumns,
    {
        key: 'count',
        title: 'Reactions',
        format: 'comma'
    }
]

const totalColumns = [
    ...defaultColumns,
    {
        key: 'count',
        title: 'Total',
        format: 'comma'
    }
]

const columnsMap = {
    page_loads: pageViewsColumns,
    comments: commentsColumns,
    reactions: reactionsColumns,
    total: totalColumns
}

const articleMetricMap = (name) => {
    return articlesMetricOptions.filter(avatarPack => avatarPack.value === name)?.pop() || articlesMetricOptions[0]
}
/* ========== ~~~~~~~~~~ TRENDING NOW ANALYTICS - TOP ARTICLES REPORT ~~~~~~~~~~ ========== */
const TopArticlesReport = injectSheet(styles)((props) => {
    const dispatch = useDispatch()
    const { data, status } = useSelector((state) => state.trendingNowV2.topArticlesByEngagement);
    const { selectedMetric, selectMetric, requestData } = props
    

    const handleExportDataTransform = (obj) => obj.map(row => {
        const formattedRow = {};
        columnsMap[selectedMetric].forEach(columnConfig => {
            formattedRow[columnConfig.key] = row[columnConfig.key];
            if(columnConfig.key === 'count') {
                if(selectedMetric === 'page_loads') formattedRow['page_loads'] = row[columnConfig.key]
                if(selectedMetric === 'comments') formattedRow['comments'] = row[columnConfig.key]
                if(selectedMetric === 'reactions') formattedRow['reactions'] = row[columnConfig.key]
                if(selectedMetric === 'total') formattedRow['total '] = row[columnConfig.key]
            }
        })
        return formattedRow;
    });

    const exportDataConfig = {
        fileName: 'top_articles_by_engagement',
        excludedColumns: ['count'],
        transpiler: handleExportDataTransform
    };
    const exportAllDataConfig = {
        onClick: () => {
            dispatch(fetchTopArticlesExportAll(requestData));
        }
    }
    const includeTotalColumn = (data) => {
        return data.map(row => {
            return {
                ...row,
            }
        })
    };

    const tooltip = useMemo(() => {
        if(selectedMetric === 'page_loads') {
            return {
                title: 'Page View',
                content: 'Shows a list of the top articles on your site ranked by the total number of page views.'
            }
        }
        if(selectedMetric === 'comments') {
            return {
                title: 'Comments',
                content: 'Displays a list of the top articles on your site based on the number of comments each article has received.'
            }
        }
        if(selectedMetric === 'reactions') {
            return {
                title: 'Reactions',
                content: 'Shows a list of the top articles on your site ranked by the number of emoji reactions each article has received.'
            }
        }
        if(selectedMetric === 'total') {
            return {
                title: 'Total',
                content: 'Shows a list of the top articles on your site ranked by the total number of interactions (comments, reactions, page views) each article has received.'
            }
        }
    }, [selectedMetric])

    return (
        <div name={'toparticlesreport'} class={`${props.classes.toparticlesreport}`} >
            <Space direction={'column'} gap={20}>
                <Space justifyContent={'space-between'}>
                    <p>Top Articles by Engagement</p>
                    <Tip 
                        space={'left'} 
                        icon={'question-circle'} 
                        content={
                            <div className={'tip-content'}>
                                <div className={'tip-title'}>
                                    <h4>{tooltip.title}</h4>
                                </div>
                                <div className={'tip-desc'}>
                                    <p>{tooltip.content}</p>
                                </div>
                            </div>
                        }
                    />
                </Space>
                <SingleSelectDropDown 
                    name={articleMetricMap(selectedMetric).name} 
                    searchable={false} 
                    onSelect={(opt) => selectMetric(opt.value)} 
                    items={articlesMetricOptions}
                />
                <TableReportSection
                    columns={columnsMap[selectedMetric]}
                    data={includeTotalColumn(data.slice(0, 20))}
                    rowsPerPage={5}
                    exportData={exportDataConfig}
                    exportAll={exportAllDataConfig}
                    loading={status === 'pending'}
                />
            </Space>
            
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TopArticlesReport;
